export const ROUTER = {
  HOME: "/",
  DISQUALIFIED: "/disqualified",
};
